<div
  class="side-info"
  (mouseleave)="mouseover = false"
  (mouseover)="mouseover = true"
  [ngClass]="{ closed: !sectionStates[scopeSection.id], open: sectionStates[scopeSection.id] }">
  <div
    class="flex flex-col justify-center settings"
    [ngClass]="{ visible: mouseover, hidden: !mouseover }">
    <span class="arrow-icon">
      <mat-icon
        class="material-symbols-rounded expand-icon"
        aria-label="Expand"
        [ngClass]="{ 'stage-open': sectionStates[scopeSection.id] === true }"
        (click)="openStage()"
        matSuffix>
        expand_more
      </mat-icon>
    </span>
    <span class="arrow-icon">
      <mat-icon
        class="material-symbols-rounded expand-icon"
        aria-label="Expand"
        [matMenuTriggerFor]="taskOptionsMenu"
        matSuffix>
        more_horiz
      </mat-icon>
    </span>
  </div>
  <mat-menu
    #taskOptionsMenu="matMenu"
    backdropClass="scope-options-menu">
    <ng-container *ngFor="let option of stageActions">
      <mat-divider
        *ngIf="option.showDivider && (option.isVisible ? option.isVisible(currentScope) : true)"></mat-divider>
      <button
        (click)="option.click()"
        *ngIf="option.isVisible ? option.isVisible(currentScope) : true"
        mat-menu-item
        class="scope-option">
        <mat-icon class="material-symbols-rounded orange">{{ option.icon }}</mat-icon>
        <span class="scope-option-name">{{ option.name() }}</span>
      </button>
    </ng-container>
  </mat-menu>
  <mat-icon
    class="material-symbols-rounded flag-icon"
    [ngClass]="{ visible: !mouseover, hidden: mouseover }"
    >flag</mat-icon
  >
  <div class="vertical-text">
    <span
      class="name"
      matTooltip="{{ scopeSection.name }}"
      [matTooltipDisabled]="!getNameTooLong()"
      >{{ scopeSection.name }}</span
    >
    <div class="cost-margin">
      <span class="tag"> MARGIN </span>
      <span class="margin">
        {{
          currentScope.getAvgMarginOfSection(scopeSection.id)
            ? currentScope.getAvgMarginOfSection(scopeSection.id) + '%'
            : '0%'
        }}
      </span>
      <span class="tag"> PRICE </span>
      <span class="margin">
        {{
          scopeSection.getTotalSellingPrice(currentScope).amount | convertCurrency: exchangeRateService.selectedCurrency
        }}
      </span>
    </div>
  </div>
</div>

<div
  [cdkDropListConnectedTo]="sectionDrops"
  class="flex section-deliverable-droplist"
  [ngClass]="{ 'drag-target': scopeTabService.deliverableDragging }"
  cdkDropList
  [ngStyle]="{ 'min-width': scopeTabService.deliverableDragging ? '50px' : '0px' }"
  id="list-{{ scopeSection.id }}"
  [cdkDropListData]="sortedSectionDeliverables"
  [cdkDropListOrientation]="'horizontal'"
  [cdkDropListAutoScrollStep]="10"
  [cdkDropListDisabled]="!scopeApprovalFlowService.isScopeEditable(currentScope)"
  (cdkDropListDropped)="dropDeliverable($event, scopeSection)">
  <div [hidden]="sortedSectionDeliverables.length > 0 || sectionStates[scopeSection.id] === false">
    <div class="template-task-main justify-center h-full">
      <div class="vertical-empty-message">
        <p class="empty-message">Drag &amp; Drop tasks</p>
        <p class="empty-message">between stages or from the ungrouped tasks on the right</p>
      </div>
    </div>
  </div>

  <scope-by-role-task
    [hidden]="sectionStates[scopeSection.id] === false"
    *ngFor="let deliverable of sortedSectionDeliverables | orderBy: 'order'; trackBy: trackById"
    cdkDrag
    [cdkDragData]="deliverable"
    (cdkDragStarted)="onTaskDragStart(); scopeTabService.deliverableDragging = true"
    [deliverable]="deliverable"
    [currentUser]="currentUser"
    [currentRatecard]="currentRatecard"
    [scopeVersion]="currentScope"
    [tableExpanded]="tableExpanded"
    [departmentSort]="departmentSort"
    [cdnConfig]="cdnConfig"
    (tableExpandedChange)="tableExpandedChanged($event)"
    (deleteTask)="deleteDeliverable(deliverable)"
    (onAcceptDeliverable)="acceptDeliverable($event)"
    (onRejectDeliverable)="rejectDeliverable($event)">
  </scope-by-role-task>
</div>
